module.exports = __webpack_public_path__ + "img/Componentes-05.3ab58cac.png";